import React from "react";
import point from "./../../../../Images/point.png";

const LashesInUptownBenefits = () => {
  return (
    <div className="hairsalonInUptownWhyChoose">
      <h5>Benefits of Getting Eye Lashes in Uptown Whitefield at SCENT</h5>
      <p>
        Still wondering whether lash extensions are right for you? Here are some
        of the many benefits of getting Eye Lashes in Uptown Whitefield at
        SCENT:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Time-Saving Beauty Routine:{" "}
          </span>
          <p>
            With lash extensions, you can cut down on your daily makeup routine.
            No more fiddling with mascara or eyelash curlers—your eyes will
            always look defined and polished, even without makeup.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Customized Results:{" "}
          </span>
          <p>
            Our expert lash technicians work closely with you to achieve your
            desired look, whether you want natural lashes for everyday wear or
            dramatic lashes for a special occasion.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Boosted Confidence:{" "}
          </span>
          <p>
            Full, voluminous lashes have the power to enhance your overall
            appearance and boost your confidence. With Eye Lashes in Uptown
            Whitefield, you’ll feel more confident knowing your eyes look
            stunning at all times.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Long-Lasting Results:{" "}
          </span>
          <p>
            Unlike mascara or false lashes, lash extensions last for several
            weeks with proper care. At SCENT, we ensure that your Eye Lashes in
            Uptown Whitefield look fabulous and last as long as possible with
            our high-quality products and expert application techniques.
          </p>
        </li>{" "}
      </ul>
    </div>
  );
};

export default LashesInUptownBenefits;
